export const state = () => ({
	token: null,
	user: null,
	searchPackage: null,
});

export const mutations = {
	setToken(state, token) {
		state.token = token;
		localStorage.setItem('token', token);
	},
	setUser(state, user) {
		state.user = user;
	},
	setSearchPackage(state, value) {
		state.searchPackage = value;
	},
};

export const getters = {
	isAuthUser(state, getters) {
		return state.token !== null;
	},
	loggedUser(state, getters) {
		return state.user;
	},
	searchPackage(state, getters) {
		return state.searchPackage;
	},
};
